import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Products">
                            <h2>Converting Your Ideas Into Exceptional Digital Products With Our Experienced Research And Development Teams</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>TekRevol specializes in developing state-of-the-art ideas and exceptional digital products backed by vital and researched facts and figures. We expedite the process from the discovery phase to the development – we convert your ideas into exceptional digital products and help them withstand the test of time with effective planning.</p>
                       <p>No matter which industry it belongs to, we understand the importance of your idea. We approach each thought with a newer perspective, a different angle to pursue all its aspects and deliver what we are confident about.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;